<template>
    <div
        class="video-content"
        @click="contentClick"
    >
        <slot name="bannerVideo" :setRef="setRef"></slot>
        <slot name="bannerMask"></slot>
    </div>
</template>
<script>
import util from '@/common/util';
export default {
    name: 'BannerVideoContent',
    props: {
        videoOption: {
            type: Object,
            default: () => {    }
        }
    },
    methods: {
        setRef(ref) {
            this.bannerVideo = ref;
        },
        contentClick(evt) {
            if (!this.platform.isMobile) {
                const bannerVideoVm = this.bannerVideo;
                const target = evt.target;
                if (
                    util.closest(target, 'video') &&
                    this.videoOption.showProgress
                    || !bannerVideoVm
                ) {
                    return; 
                }
                if (!bannerVideoVm.isPause) {
                    this.doVideoPause();
                } else {
                    this.doVideoPlay();
                }
            }
        },
        doVideoPlay() {
            this.bannerVideo && this.bannerVideo.doPlay();
        },
        doVideoPause() {
            this.bannerVideo && this.bannerVideo.doPause();
        }
    }
}
</script>